/**
 * Platform detection utilities for keyboard shortcut display.
 *
 * Uses navigator.userAgentData.platform (Chromium) with navigator.platform
 * as a fallback. Returns empty strings on touch-only devices so shortcuts
 * aren't shown.
 */

const isTouchOnly = typeof window !== 'undefined' && 'ontouchstart' in window && !(typeof window.matchMedia === 'function' && window.matchMedia('(pointer: fine)').matches);

// userAgentData.platform is the modern API (Chromium-based browsers including
// Tauri's WebView). navigator.platform is deprecated but kept as a fallback
// for non-Chromium environments (Firefox, older Safari).
export const isMacOS = typeof navigator !== 'undefined' && /mac/i.test(
  (navigator as unknown as { userAgentData?: { platform: string } }).userAgentData?.platform
  ?? navigator.platform
);

/**
 * Format a keyboard shortcut for display.
 *
 * @param mac  - Mac shortcut (e.g. '⌘\\')
 * @param other - Windows/Linux shortcut (e.g. 'Ctrl+\\')
 * @returns Formatted string, or empty string on touch-only devices
 *
 * @example
 * shortcutLabel('⌘\\', 'Ctrl+\\')  // "⌘\" on Mac, "Ctrl+\" on Windows, "" on mobile
 * shortcutLabel('⌘K', 'Ctrl+K')     // "⌘K" on Mac, "Ctrl+K" on Windows
 */
export function shortcutLabel(mac: string, other: string): string {
  if (isTouchOnly) return '';
  return isMacOS ? mac : other;
}
